import { ChevronLeft } from "lucide-react";
import { TopBar } from "@/components/shared/TopBar";
import { Button } from "@stackje/shared-components/ui/button";
import { Link, useSearch } from "@tanstack/react-router";

export default function ChooseCardToAddPage() {
  const search = useSearch({ from: '/_protected/_site/add-card/' });
  const cards = [
    {
      title: "Hero",
      description:
        "Quickly catch your audience’s attention and call them to take action. Optionally list social links. Often used as the first card.",
      path: "hero",
    },
    {
      title: "Text",
      description: "Simple text-only card with title and text section.",
      path: "text",
    },
    {
      title: "Links",
      description:
        "Showcase a set of buttons or cards (with images, optionally), like a link-in-bio.",
      path: "links",
    },
    {
      title: "Images",
      description:
        "Display a collection of images with captions in various layouts - perfect for galleries or portfolios.",
      path: "images",
    },
    {
      title: "Features",
      description:
        "Highlight key features, benefits, or selling points with images and descriptions.",
      path: "features",
    },
    {
      title: "FAQs",
      description:
        "Show a series of questions and answers.",
      path: "faq",
    },
    {
      title: "WhatsApp",
      description:
        "Add a direct WhatsApp chat button with customizable pre-filled message and CTA.",
      path: "whatsapp",
    },
    {
      title: "Buy Me a Teh",
      description:
        "Add a tipping section where visitors can support you with PayNow QR payments with customizable amounts.",
      path: "tipping",
    },
  ];

  return (
    <div className="pt-12">
      <TopBar>
        <Button variant="ghost" size="icon" onClick={() => history.back()}>
          <ChevronLeft className="h-5 w-5" />
        </Button>
        <h1>Add a Card</h1>
        <div className="w-6"></div>
      </TopBar>

      <div className="container mx-auto px-4 py-8 max-w-2xl h-full">
        <div className="grid gap-4">
          {cards.map((card, index) => (
            <Link
              key={index}
              to={`/add-card/$cardType`}
              params={{ cardType: card.path }}
              search={search}
              className="cursor-pointer"
            >
              <div className="bg-white border shadow rounded-lg p-4 hover:bg-gray-50 transition-colors">
                <h2 className="text-xl font-semibold">{card.title}</h2>
                <p className="text-gray-600">{card.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
